module.exports = __webpack_public_path__ + "static/fonts/Poppins-ThinItalic.01555d2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-ThinItalic.ttf
// module id = 1034
// module chunks = 11